<template>
  <div id="contenedor-opciones-tool-bar">
    <v-tabs>
      <v-tab
        v-for="(opcion, index) in opciones"
        :key="index"
        :to="{ name: opcion.ruta }"
        exact>
        {{ opcion.nombre }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'OpcionesToolBar',
  data() {
    return {
      opciones: [
        {
          nombre: 'Generales',
          ruta: 'contratoEstimacionesDefault',
          icono: '',
        },
        {
          nombre: 'Estimaciones',
          ruta: 'contratoEstimaciones',
          icono: '',
        },
        {
          nombre: 'Escalatorias',
          ruta: 'constratoEstimacionesEscalatorias',
          icono: '',
        },
        {
          nombre: 'Gastos',
          ruta: 'constratoEstimacionesGastos',
          icono: '',
        },
        {
          nombre: 'Anticipos',
          ruta: 'contratoEstimacionesAnticipos',
          icono: '',
        },
        {
          nombre: 'Convenios Mod.',
          ruta: 'contratoEstimacionesConveniosModificatorios',
          icono: '',
        },
        {
          nombre: 'Catálogo',
          ruta: 'contratoEstimacionesCatalogo',
          icono: '',
        },
        {
          nombre: 'Programa',
          ruta: 'contratoEstimacionesPrograma',
          icono: '',
        },
        {
          nombre: 'Expediente',
          ruta: 'contratoEstimacionesExpediente',
          icono: '',
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
